import { useHistory } from "react-router-dom";
import { auth } from "../FIREBASE/firebase";
import routeUrls from "../COMPONENTS/navbar/navLink";
import "../CSS/login.scss";
import { usePageBackground } from "../COMPONENTS/usePageBackground";

export const LoggedInView = () => {
  const history = useHistory();
  usePageBackground();

  const handleLogout = async () => {
    await auth.signOut();
    history.push(routeUrls.HOME);
  };

  return (
    <div className="login">
      <div className="login__box">
        <h1 className="login__title">Inloggad</h1>
        <button className="login__submit" onClick={() => history.push(routeUrls.TRAINING)}>
          Träning
        </button>
        <button className="login__submit login__submit--secondary" onClick={() => history.push(routeUrls.ADMIN)}>
          Admin
        </button>
        <button className="login__submit login__submit--outline" onClick={handleLogout}>
          Logga ut
        </button>
      </div>
    </div>
  );
};
